import { createContext, useContext } from 'react';

interface VariableDropdownContextType {
  openVariableDropdown?: (
    currentVarName: string,
    isSystem: boolean,
    nodePos: number,
    element?: HTMLElement
  ) => void;
}

const VariableDropdownContext = createContext<VariableDropdownContextType>({});

export const useVariableDropdown = (): VariableDropdownContextType => {
  return useContext(VariableDropdownContext);
};

export default VariableDropdownContext;
